<template>
  <div>
    <modal name="filter-modal" height="auto">
      <div>
        <div class="d-flex justify-content-between attendance-modal-header">
          <div class="modal-header-left">
            <h3>{{ $t("planing.advanceFilterHeading") }}</h3>
          </div>
          <div class="modal-header-right">
            <a @click="$modal.hide('filter-modal')"> ❌ </a>
          </div>
        </div>
        <div class="d-flex">
          <div class="modal-left-bar">
            <ul>
              <li>
                <a href="#" @click="getData(1)">
                  {{ $t("planing.advanceFilter.groups") }}
                </a>
              </li>
              <li>
                <a href="#" @click="getData(0)">
                  {{ $t("planing.advanceFilter.structure") }}
                </a>
              </li>
              <li v-if="isCeo">
                <a href="#" @click="getData(2)">
                  {{ $t("planing.advanceFilter.manager") }}
                </a>
              </li>
              <li>
                <a href="#" @click="getData(3)">
                  {{ $t("planing.advanceFilter.status") }}
                </a>
              </li>
              <li>
                <a href="#" @click="getData(4)">
                  {{ $t("planing.advanceFilter.leaveTypes") }}
                </a>
              </li>
            </ul>
          </div>
          <div class="modal-right-content pl-3 pt-3">
            <div v-if="showSelectAll">
              <label class="checkbox-main" for="select-all">
                {{ $t("planing.advanceFilter.selectAll") }}
                <input type="checkbox" id="select-all" v-model="selectAll" />
                <span class="checkmark"></span>
              </label>
            </div>
            <div v-for="(data, index) in filters" :key="index">
              <label class="checkbox-main" :for="data.name">
                {{ data.name }}
                <div v-if="data.access">
                  <input
                    type="checkbox"
                    :id="data.name"
                    :value="data.reference"
                    v-model="selected.groups"
                  />
                  <span class="checkmark"></span>
                </div>
                <div v-else-if="data.zipCode">
                  <input
                    type="checkbox"
                    :id="data.name"
                    :value="data.reference"
                    v-model="selected.structures"
                  />
                  <span class="checkmark"></span>
                </div>
                <div v-else-if="data.incharge">
                  <input
                    type="checkbox"
                    :id="data.name"
                    :value="data.reference"
                    v-model="selected.managers"
                  />
                  <span class="checkmark"></span>
                </div>
                <div v-else-if="data.leaveType">
                  <input
                    type="checkbox"
                    :id="data.name"
                    :value="data.reference"
                    v-model="selected.leaves"
                  />
                  <span class="checkmark"></span>
                </div>
                <div v-else>
                  <input
                    type="checkbox"
                    :id="data.name"
                    :value="data.reference"
                    v-model="selected.status"
                  />
                  <span class="checkmark"></span>
                </div>
              </label>
            </div>
          </div>
        </div>
        <div class="d-flex m-4 justify-content-end">
          <button type="button" class="btn btn-info" @click="saveSearch()">
            <i class="fa fa-home"></i>
            {{ $t("planing.advanceFilter.saveButtonText") }}
          </button>
          <button
            type="button"
            class="btn btn-secondary ml-3"
            @click="$modal.hide('filter-modal')"
          >
            {{ $t("planing.advanceFilter.cancelButtonText") }}
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import groups from '@/data/groups/Groups';

export default {
  props: ['resources', 'users'],
  data() {
    return {
      selected: {
        groups: [],
        structures: [],
        managers: [],
        status: [],
        leaves: [],
      },
      advanceFilterResources: [],
      groups,
      structureList: [],
      filters: [],
      users: [],
      whichFilter: -1,
      isManager: false,
      ceo: false,
      leaveTypes: [
        {
          name: this.$t('menu.ask.days.off'),
          leaveType: 'leave',
          reference: 'DAYS_OFF',
        },
        {
          name: this.$t('menu.ask.simple.absence'),
          leaveType: 'leave',
          reference: 'SIMPLE_ABSENCE',
        },
        {
          name: this.$t('menu.ask.retrieve.hours'),
          leaveType: 'leave',
          reference: 'RECOVERY_TIME_REQUEST',
        },
        {
          name: this.$t('leave.medical'),
          leaveType: 'leave',
          reference: 'Médicale',
        },
        {
          name: this.$t('leave.training'),
          leaveType: 'leave',
          reference: 'Formation',
        },
      ],
      managers: [],
      showSelectAll: false,
    };
  },

  async mounted() {
    // by default select All group filters
    this.groups.forEach((g) => {
      this.selected.groups.push(g.reference);
    });
    this.selected.status = ['accepted'];
    this.selected.leaves = [
      'DAYS_OFF',
      'SIMPLE_ABSENCE',
      'RECOVERY_TIME_REQUEST',
      'Médicale',
      'Formation',
    ];
  },

  computed: {
    getGroups() {
      this.$emit('updateGroup', this.selected.groups);
    },

    getStructure() {
      this.$emit('updateStructure', this.selected.structures);
    },

    getManager() {
      this.$emit('updateManager', this.selected.managers);
    },

    getStatus() {
      this.$emit('updateStatus', this.selected.status);
    },

    getLeaveTypes() {
      this.$emit('updateLeaveTypes', this.selected.leaves);
    },

    isCeo() {
      this.$store.state.user.informations.permissions.forEach((p) => {
        if (p.groupReference == '_super_admin') {
          this.ceo = true;
        }
      });
      return this.ceo;
    },

    selectAll: {
      get() {
        if (this.whichFilter == 1) {
          return this.selected.groups.length == this.filters.length;
        } else if (this.whichFilter == 0) {
          return this.selected.structures.length == this.filters.length;
        } else if (this.whichFilter == 2) {
          return this.selected.managers.length == this.filters.length;
        } else if (this.whichFilter == 3) {
          return this.selected.status.length == this.filters.length;
        }
        return this.selected.leaves.length == this.filters.length;
      },
      set(value) {
        const selected = [];
        if (value) {
          this.filters.forEach((filter) => {
            selected.push(filter.reference);
          });
        }
        if (this.whichFilter == 1) {
          this.selected.groups = selected;
        } else if (this.whichFilter == 0) {
          this.selected.structures = selected;
        } else if (this.whichFilter == 2) {
          this.selected.managers = selected;
        } else if (this.whichFilter == 3) {
          this.selected.status = selected;
        } else {
          this.selected.leaves = selected;
        }
      },
    },
  },
  watch: {
    users: [
      {
        handler: 'getusers',
      },
    ],
  },

  methods: {
    getData(flag) {
      this.whichFilter = flag;
      if (flag == 0) {
        this.showSelectAll = true;
        this.filters = [];
        this.filters = this.$store.state.structure.list;
      } else if (flag == 1) {
        this.showSelectAll = true;
        this.filters = [];
        this.filters = this.groups;
      } else if (flag == 2) {
        this.showSelectAll = true;
        this.filters = [];
        this.users.filter((user) => {
          user.permissions.forEach((u) => {
            if (u.groupReference == '_in_charge') {
              this.filters.push({
                name: user.firstName.concat(` ${user.lastName}`),
                reference: user.reference,
                incharge: true,
              });
            }
          });
        });
      } else if (flag == 3) {
        this.showSelectAll = true;
        this.filters = [
          {
            name: this.$t('planing.advanceFilter.status.accepted'),
            reference: 'accepted',
          },
          {
            name: this.$t('planing.advanceFilter.status.pending'),
            reference: 'Pending',
          },
          {
            name: this.$t('planing.advanceFilter.status.rejected'),
            reference: 'rejected',
          },
        ];
      } else {
        this.showSelectAll = true;
        this.filters = this.leaveTypes;
      }
    },

    saveSearch() {
      this.getGroups; // calling group emit in parent
      this.getStructure; // calling structure emit in parent
      this.getManager; // calling manager emit in parent
      this.getStatus; // calling status emit in parent
      this.getLeaveTypes; // calling leave emit in parent
      this.advanceFilterResources = [];
      this.users.filter((user) => {
        user.permissions.forEach((u) => {
          if (
            this.selected.managers.includes(user.reference) ||
            this.selected.groups.includes(u.groupReference) ||
            this.selected.structures.includes(user.structureReference)
          ) {
            this.advanceFilterResources.push({
              id: user.reference,
              title: user.firstName.concat(' ', user.lastName),
            });
          }
        });
        // getting employees under particular Manager
        user.inCharge.forEach((u) => {
          this.selected.managers.includes(u.userReference)
            ? this.advanceFilterResources.push({
              id: user.reference,
              title: user.firstName.concat(' ', user.lastName),
            })
            : '';
        });
      });
      const result = Array.from(new Set(this.advanceFilterResources.map(x => x.id))).map(id => ({
        id,
        title: this.advanceFilterResources.find(s => s.id === id).title,
      }));
      this.$emit('updatedResources', result);
      this.$modal.hide('filter-modal');
    },

    getusers(el) {
      this.$store.state.structure.list.forEach((st) => {
        this.selected.structures.push(st.reference);
      });
      this.users.filter((user) => {
        user.permissions.forEach((u) => {
          if (u.groupReference == '_in_charge') {
            this.selected.managers.push(user.reference);
          }
        });
      });
    },
  },
};
</script>

<style lang="scss">
.attendance-modal-header {
  border-bottom: 1px solid #ddd;
  padding: 0 20px;
  .modal-header-left {
    h3 {
      font-size: 18px;
      margin: 0;
      padding: 7px 0;
      color: #9a9898;
    }
  }
  .modal-header-right {
    border-left: 1px solid #dddd;
    padding-left: 15px;
    padding: 7px 0;
    a {
      cursor: pointer;
      display: inline-block;
      padding-top: 10px;
      padding-left: 15px;
    }
  }
}
.vacation-section {
  padding: 10px 20px;
  .vacation-number {
    width: 50px;
    height: 50px;
    border: 3px solid #86b6b8;
    border-radius: 50px;
    text-align: center;
    line-height: 40px;
    margin-right: 10px;
    p {
      margin: 0;
      font-size: 20px;
    }
  }
  .vacation-details {
    margin-right: 10px;
    h4 {
      margin: 0;
      font-size: 17px;
      font-weight: 700;
    }
    p {
      margin: 0;
    }
  }
  .vacation-account {
    ul {
      margin: 29px 0 0 0;
      padding: 0;
      text-align: right;
    }
    li {
      list-style-type: none;
      width: 50%;
      float: left;
    }
  }
}
.modal-left-bar {
  width: 200px;
  background-color: #f6f7f8;
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  max-height: 300px;
  height: 200px;
  overflow-y: auto;
  ul {
    margin: 0;
    padding: 0;
    li {
      list-style-type: none;
    }
    a {
      text-decoration: none;
      padding: 7px 15px;
      display: inline-block;
      width: 100%;
      transition: 0.5s;
      font-weight: 700;
      color: #5a5a5a;
      &:hover {
        background-color: #e7e4e4;
      }
    }
  }
}
.checkbox-main {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 16px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: transparent;
    border: 2px solid #86b6b8;
    &:after {
      content: "";
      position: absolute;
      display: none;
    }
    &:after {
      left: 5px;
      top: 0px;
      width: 7px;
      height: 12px;
      border: solid #fff;
      border-width: 0 2px 2px 0;
      -webkit-transform: rotate(45deg);
      transform: rotate(45deg);
    }
  }
  &:hover {
    input ~ .checkmark {
      background-color: transparent;
    }
  }
  input:checked ~ .checkmark {
    background-color: #86b6b8;
    &:after {
      display: block;
    }
  }
}
</style>
